import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-54" data-mp="15d3ys4758mma">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-55" data-mp="15fq5k1m7my3g">
        {showUrgency && <CountdownPanel headline="Te quedan menos de 48 horas para acceder a este precio especial" subtext="Después vuelve a $24.990 | Hoy: $14.990 + 3 bonos | Mañana es tarde" data-id="element-56" data-mp="1jasd0t6pgvid" />}

        <div className="mx-auto mt-14 max-w-narrow text-center" data-id="element-57" data-mp="1o3bonklu1gkj">
          <h2 className="font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-58" data-mp="1o5y4e7ivn2du">
            Tu oportunidad es ahora
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-59" data-mp="1x64h3r6r3yby">
            Tenés todo lo que necesitás para transformar tu campaña de Septiembre Amarillo en una
            experiencia que realmente salva vidas. El material existe. La estrategia existe. Los
            testimonios existen. Los bonos existen. Solo falta tu decisión.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-60" data-mp="123em6vgosugl">
            No dejes que otro año pase viendo cómo otros profesionales tienen las herramientas y vos
            no.{' '}
            <span className="font-display font-extrabold text-night" data-id="element-61" data-mp="1b2rv9n0wfh0s">
              La salud mental no puede esperar.
            </span>
          </p>
          <p className="mt-5 text-lg text-gray-600" data-id="element-62" data-mp="1fwcx5q5m4v59">
            Recordá: tenés 7 días de garantía. Si no te convence, te devolvemos todo. Sin riesgo.
          </p>

          <div className="mt-10" data-id="element-63" data-mp="1pthcb611jqck">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-64" data-mp="1pqcyri1ori98">
              🟢 Acceder al protocolo ahora
            </CtaButton>
          </div>

          <TrustIcons className="mt-8" data-id="element-65" data-mp="3qvqjjv5kz2lw" />
        </div>
      </div>
    </section>;
}